/*
 * @Author: zjw
 * @Date: 2021-06-23 10:55:33
 * @LastEditTime: 2022-11-16 16:25:46
 * @FilePath: \web-app\src\network\other\email.js
 * @Environment: Vue + Element
 * @Description: email
 */
import {
    request,
} from '../request.js'

// 邮箱参数
export function getEmailList(data) {
    return request({
        url: '/web/back/sys/mailConfigure/serch',
        method: 'post',
        data
    })
}

// 提交修改
export function updateEmail(data) {
    return request({
        url: '/web/back/sys/mailConfigure/update',
        method: 'post',
        data
    })
}
